import styled from 'styled-components';

import theme from '@theme';

export const StyledTypograpy = styled.h1`
  font-size: 18px;
  color: #1c1c1c;
  font-weight: 400;
  margin-top: 6px;

  ${theme.mediaQueries.LARGE_1X_UP} {
    font-size: 30px;
  }
`;

export const Wrapper = styled.div`
  padding: 0.7em;
  min-height: 68px;
  background: #e8e8e8;
`;
